export default __webpack_public_path__ + "static/media/Pencil.d54e5ea3.svg";